import React from "react";

export default function STDEV_S() {
  return <div>Excel_STDEV_S</div>;
}
